// extracted by mini-css-extract-plugin
export var embedContainer = "youtube-module--embed-container--c8299";